module.exports = __webpack_public_path__ + "fixed-background-1.01c545d81bfe5fc97fcd.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/img/fixed-background-1.jpg
// module id = ../../../../../src/assets/img/fixed-background-1.jpg
// module chunks = styles